import React from 'react';
import { Col, Label, Row } from 'reactstrap';
import { AvGroup } from 'availity-reactstrap-validation';
import AvField from '../../../shared/component/form/AvField';
import PropTypes from 'prop-types';
import Translate from "../../../shared/language/Translate";
import { PhoneField } from "../../../shared/component/form/PhoneField";
import {
    ASSET_CATEGORY,
    PAGE_MODE
} from "../../../shared/utils/Constants";
import { Fieldset } from "primereact/fieldset";
import StatusGroup from "../../../shared/component/hsmGroup/StatusGroup";
import MobileService from '../../../shared/service/MobileService';
import CityService from '../../../shared/service/CityService';
import DistrictService from '../../../shared/service/DistrictService';
import AvFieldForMac from '../../../shared/component/form/AvFieldForMac';
import DateInput from "../../../shared/component/form/DateInput";

const defaultMobile = {
    assetCategory: 'MOBILE',
    id: null,
    username: '',
    keyword: '',
    phone: '',
    status: 'A',
    ssidName: '',
    password: '',
    wanIp: '',
    cityId: 1,
    districtId: '',
    description: '',
    orderDate: '',
    deliveryDate: '',
    routerSerialNo: '',
    routerMacAddress: '',
};
const ASSET_CATEGORY_LIST = [
    { name: 'Mobil', value: 'MOBILE', id: 8 }
];

export default class MobileSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mobile: Object.assign({}, defaultMobile),
            disabledAssetCategory: true,
            cityList: [],
            districtList: [],
            pageMode: null,
            disabledGeneric: false
        }
        this.service = new MobileService();
        this.cityService = new CityService();
        this.districtService = new DistrictService();
    }

    componentDidMount = () => {
        this.cityService.findAll().then(response => this.setState({ cityList: response }));
        this.findDistrictByChangedCityId(this.state.mobile.cityId);
    }

    render() {
        return (
            <div>
                <Row className="container">
                    <Col>
                        <AvGroup>
                            <Label for="assetCategory">
                                <Translate contentKey="asset-management.assetCategory">Varlık Sınıfı</Translate>
                                <span style={{ color: 'red' }}> (*)</span>
                            </Label>
                            <AvField
                                type="select"
                                className="form-control"
                                name="assetCategory"
                                value={this.state.mobile.assetCategory}
                                validate={this.state.pageMode === PAGE_MODE.VIEW ? {} : {
                                    required: {
                                        value: "true",
                                        errorMessage: "Bu alanın doldurulması zorunludur."
                                    }
                                }}
                                disabled={this.state.disabledAssetCategory}>
                                <option value='' key='' />
                                {ASSET_CATEGORY_LIST.map(element => (
                                    <option value={element.value} key={element.value}>
                                        {element.name}
                                    </option>
                                ))}
                            </AvField>
                        </AvGroup>

                        <AvGroup>
                            <Label for="username">
                                <Translate contentKey="asset-management.username">Kullanıcı Adı</Translate>
                                <span style={{ color: 'red' }}> (*)</span>
                            </Label>
                            <AvField
                                type="text"
                                className="form-control"
                                name="username"
                                validate={this.state.pageMode === PAGE_MODE.VIEW ? {} : {
                                    maxLength: {
                                        value: 255,
                                        errorMessage: "Bu alana en fazla 255 karakter girebilirsiniz."
                                    },
                                    required: {
                                        value: "true",
                                        errorMessage: "Bu alanın doldurulması zorunludur."
                                    }
                                }}
                                value={this.state.mobile.username}
                                onChange={this.__handleChange}
                                disabled={this.state.pageMode === PAGE_MODE.VIEW}
                            />
                        </AvGroup>
                        <AvGroup>
                            <Label for="keyword">
                                <Translate contentKey="asset-management.keyword">Parola</Translate>
                                <span style={{ color: 'red' }}> (*)</span>
                            </Label>
                            <AvField
                                type="text"
                                className="form-control"
                                name="keyword"
                                validate={this.state.pageMode === PAGE_MODE.VIEW ? {} : {
                                    maxLength: {
                                        value: 255,
                                        errorMessage: "Bu alana en fazla 255 karakter girebilirsiniz."
                                    }, required: {
                                        value: "true",
                                        errorMessage: "Bu alanın doldurulması zorunludur."
                                    }
                                }}
                                value={this.state.mobile.keyword}
                                onChange={this.__handleChange}
                                disabled={this.state.pageMode === PAGE_MODE.VIEW}
                            />
                        </AvGroup>

                        <AvGroup>
                            <Label for="phone">
                                <Translate contentKey="asset-management.phone">GSM No</Translate>
                            </Label>
                            <PhoneField kind={'mobile'}
                                name="phone" errorMessage="Geçersiz Numara Girişi"
                                value={this.state.mobile.phone}
                                onChange={this.__handleChange}
                            />
                        </AvGroup>
                        <AvGroup>
                            <Label for="ssidName">
                                <Translate contentKey="asset-management.ssidName">SSID ADI</Translate>
                                <span style={{ color: 'red' }}> (*)</span>
                            </Label>
                            <AvField
                                type="text"
                                className="form-control"
                                name="ssidName"
                                validate={this.state.pageMode === PAGE_MODE.VIEW ? {} : {
                                    maxLength: {
                                        value: 255,
                                        errorMessage: "Bu alana en fazla 255 karakter girebilirsiniz."
                                    },
                                    required: {
                                        value: "true",
                                        errorMessage: "Bu alanın doldurulması zorunludur."
                                    }
                                }}
                                value={this.state.mobile.ssidName}
                                onChange={this.__handleChange}
                                disabled={this.state.pageMode === PAGE_MODE.VIEW}
                            />
                        </AvGroup>
                        <AvGroup>
                            <Label for="password">
                                <Translate contentKey="asset-management.password">Şifre</Translate>
                                <span style={{ color: 'red' }}> (*)</span>
                            </Label>
                            <AvField
                                type="text"
                                className="form-control"
                                name="password"
                                validate={this.state.pageMode === PAGE_MODE.VIEW ? {} : {
                                    maxLength: {
                                        value: 100,
                                        errorMessage: "Bu alana en fazla 100 karakter girebilirsiniz."
                                    },
                                    required: {
                                        value: "true",
                                        errorMessage: "Bu alanın doldurulması zorunludur."
                                    }
                                }}
                                value={this.state.mobile.password}
                                onChange={this.__handleChange}
                                disabled={this.state.pageMode === PAGE_MODE.VIEW}
                            />
                        </AvGroup>
                        <StatusGroup value={this.state.mobile.status} onChange={this.__handleChange}
                            disabled={this.state.pageMode === PAGE_MODE.VIEW} />
                        <Label for="description">
                            <Translate contentKey="asset-management.description">Açıklama</Translate>
                        </Label>
                        <AvField
                            type="textarea"
                            className="form-control textAreaHermes"
                            name="description"
                            value={this.state.mobile.description}
                            onChange={this.__handleChange}
                        />
                    </Col>
                    <Col>
                        <AvGroup>
                            <Label for="cityId">
                                <Translate contentKey="asset-management.cityId">İl Adı</Translate>
                                <span style={{ color: 'red' }}> (*)</span>
                            </Label>
                            <AvField type="select" className="form-control" name="cityId"
                                value={this.state.mobile.cityId}
                                onChange={this.__handleChangeCity}
                                validate={this.state.pageMode === PAGE_MODE.VIEW ? {} : {
                                    required: {
                                        value: true,
                                        errorMessage: "Bu alanın doldurulması zorunludur."
                                    }
                                }}
                                disabled={this.state.pageMode === PAGE_MODE.VIEW}>
                                <option value='' key='' />
                                {this.state.cityList.map(element => (
                                    <option value={element.id} key={element.id}>
                                        {element.name}
                                    </option>
                                ))}
                            </AvField>
                        </AvGroup>
                        <AvGroup>
                            <Label for="districtId">
                                <Translate contentKey="asset-management.districtId">İlçe Adı</Translate>
                                <span style={{ color: 'red' }}> (*)</span>
                            </Label>
                            <AvField type="select" className="form-control" name="districtId"
                                value={this.state.mobile.districtId}
                                onChange={this.__handleChange}
                                validate={this.state.pageMode === PAGE_MODE.VIEW ? {} : {
                                    required: {
                                        value: true,
                                        errorMessage: "Bu alanın doldurulması zorunludur."
                                    }
                                }}
                                disabled={this.state.pageMode === PAGE_MODE.VIEW}>
                                <option value='' key='' />
                                {this.state.districtList.map(element => (
                                    <option value={element.id} key={element.id}>
                                        {element.name}
                                    </option>
                                ))}
                            </AvField>
                        </AvGroup>

                        <AvGroup>
                            <Label for="wanIp">
                                <Translate contentKey="asset-management.wanIp">WAN IP Adresi</Translate>
                                <span style={{ color: 'red' }}>(*)</span>
                            </Label>
                            <AvField
                                type="text"
                                className="form-control"
                                name="wanIp"
                                validate={{
                                    maxLength: {
                                        value: 15,
                                        errorMessage: 'Bu alan en fazla 15 karakterden oluşabilir.'
                                    }
                                }}
                                placeholder="000.000.000.000"
                                value={this.state.mobile.wanIp}
                                onChange={this.__handleChange}
                            />
                        </AvGroup>
                        <Fieldset legend="Router Bilgileri">
                            <AvGroup>
                                <Label for="routerSerialNo">
                                    <Translate contentKey="asset-management.routerSerialNo">Seri No.</Translate>
                                </Label>
                                <AvField
                                    type="text"
                                    className="form-control"
                                    name="routerSerialNo"
                                    validate={this.state.pageMode === PAGE_MODE.VIEW ? {} : {
                                        maxLength: {
                                            value: 50,
                                            errorMessage: "Bu alana en fazla 50 karakter girebilirsiniz."
                                        }
                                    }}
                                    value={this.state.mobile.routerSerialNo}
                                    onChange={this.__handleChange}
                                    disabled={this.state.pageMode === PAGE_MODE.VIEW}
                                />
                            </AvGroup>
                            <AvGroup>
                                <Label for="routerMacAddress">
                                    <Translate contentKey="asset-management.routerMacAddress">MAC Adresi</Translate>
                                </Label>
                                <AvFieldForMac
                                    ref={(elem) => this.refMacAddress = elem}
                                    type="text"
                                    className="form-control"
                                    name="routerMacAddress"
                                    value={this.state.mobile.routerMacAddress}
                                    setValue={(value) => {
                                        let mobile = this.state.mobile;
                                        mobile.routerMacAddress = value;
                                        this.setState({
                                            mobile
                                        });
                                    }}
                                    onChange={this.__handleChange}
                                />
                            </AvGroup>


                        </Fieldset>
                        <div className="position-relative form-group">
                            <Label for="orderDate">
                                Talep Tarihi
                            </Label>

                            <DateInput
                                name="orderDate"
                                onChange={this.__handleChange}
                                value={this.state.mobile.orderDate} />
                        </div>

                        <div className="position-relative form-group">
                            <Label for="deliveryDate">
                                Teslim Tarihi
                            </Label>

                            <DateInput
                                name="deliveryDate"
                                onChange={this.__handleChange}
                                value={this.state.mobile.deliveryDate} />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }

    getData = () => {
        let mobile = Object.assign({}, this.state.mobile);
        mobile.cityId = { id: this.state.mobile.cityId };
        mobile.id = mobile.id ? mobile.id : null;
        mobile.districtId = { id: this.state.mobile.districtId };
        mobile.assetCategory = 'MOBILE';
        return mobile;
    }


    __handleChangeCity = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let mobile = this.state.mobile;
        mobile[e.target.name] = value;
        this.findDistrictByChangedCityId(value);
    }


    setData = (data, pageMode) => {
        this.clearData();
        this.refMacAddress.setPageMode(pageMode);
        data.cityId = data.cityId ? data.cityId.id : null;
        this.findDistrictByCityId(data, data.cityId);
        data.assetCategory = 'MOBILE';
        data.mobilId = data.mobilId ? data.mobilId : null;
        let normalizaMacAdress = this.refMacAddress.getValue();
        let mobile = this.state.mobile;
        mobile.routerMacAddress = normalizaMacAdress;

        this.setState({
            mobile: data,
            pageMode: pageMode
        });
    }


    findDistrictByCityId = (data, cityId) => {
        this.districtService.findByCityId(cityId).then(response => {
            data.districtId = data.districtId ? data.districtId.id : null;
            this.setState({ districtList: response });
        });
    }


    clearData = () => {
        this.setState({
            mobile: Object.assign({}, defaultMobile),
            pageMode: null,
        });
    }


    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let mobile = this.state.mobile;
        mobile[e.target.name] = value;
        this.setState({ mobile: mobile });
    }


    findDistrictByChangedCityId = (cityId) => {
        this.districtService.findByCityId(cityId).then(response => {
            let mobile = this.state.mobile;
            mobile.districtId = response[0].id;
            this.setState({ districtList: response, mobile: mobile });
        });
    }


    setPageMode = (pageMode) => {
        this.setState({ pageMode: pageMode });
    }

    setAssetCategory = (assetCategory) => {
        if (assetCategory === ASSET_CATEGORY.MOBILE) {
            let mobile = Object.assign({}, defaultMobile);
            mobile.assetCategory = assetCategory;
            this.setState({ mobile: mobile, disabledAssetCategory: true });
            this.getAssetTypeList(assetCategory);
        }
    }
}

MobileSave.propTypes = {
    mobile: PropTypes.object
};
